var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "heartemptyfull" }, [
    _vm.isFull === true
      ? _c(
          "div",
          {
            staticClass: "clickable d-flex",
            on: {
              click: function ($event) {
                return _vm.heartClicked($event)
              },
            },
          },
          [
            _c(
              "BaseIcon",
              { attrs: { width: "20", height: "20", viewBox: "0 0 16 14" } },
              [_c("Heart")],
              1
            ),
          ],
          1
        )
      : _c(
          "div",
          {
            staticClass: "clickable d-flex",
            on: {
              click: function ($event) {
                return _vm.heartClicked($event)
              },
            },
          },
          [
            _c(
              "BaseIcon",
              { attrs: { width: "20", height: "20", viewBox: "0 0 16 14" } },
              [_c("HeartBorder")],
              1
            ),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }